<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">创作者收入</h1>
      <p class="hint">内容销售分账入账明细（pay_type: creator_income）</p>
      <el-table :data="items" v-loading="loading" border>
        <el-table-column label="时间" width="170">
          <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" min-width="160" />
        <el-table-column prop="detail" label="说明" min-width="200" />
        <el-table-column label="金额（元）" width="110">
          <template #default="s">
            <span class="income">+{{ (s.row.amount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > pageSize"
        class="pager"
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="onPage"
      />
    </div>
  </div>
</template>

<script>
import { fetchCreatorIncome } from '@/utils/userHub'

export default {
  name: 'CreatorIncomeView',
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: 20
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(Number(ts) * 1000).toLocaleString()
    },
    async load() {
      this.loading = true
      try {
        const data = await fetchCreatorIncome({ page: this.page, pageSize: this.pageSize })
        this.items = data.items || []
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    onPage(p) {
      this.page = p
      this.load()
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 16px; }
.income { color: #67c23a; font-weight: 600; }
.pager { margin-top: 16px; justify-content: center; }
</style>
